import { render } from "./Relative.vue?vue&type=template&id=5fa20904"
import script from "./Relative.vue?vue&type=script&lang=js"
export * from "./Relative.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__